import "./new_homepage.css";


const list_img = [
  {
    icon: "./img/client_logo_1.png",
    title: "5 Discovery",
  },

  {
    icon: "./img/client_logo_2.png",
    title: "Potentials",
  },

  {
    icon: "./img/client_logo_3.png",
    title: "Univ Clermont-Ferrant",
  },

  {
    icon: "./img/client_logo_5.png",
    title: "Ecole aromathérapie ",
  },

  {
    icon: "./img/client_logo_6.png",
    title: "Groupe CAPL",
  },

  {
    icon: "./img/client_logo_1.png",
    title: "5 Discovery",
  },

  {
    icon: "./img/client_logo_2.png",
    title: "Potentials",
  },

  {
    icon: "./img/client_logo_3.png",
    title: "Univ Clermont-Ferrant",
  },

];

const LogoCloud = () => {
  return (
    <div className='new_homepage_2025'>
      <div className="LogoCloud_block1" >
        <h2 className="LogoCloud_h2">
          50+ Organismes de Formation ont confiance en Mysy Training
        </h2>

        <div className='block_logo_client'>

          <div className='LogoCloud_cb1'>
            <div className='LogoCloud_cb2'>

              {list_img.map((value, index) => (
                <div className='LogoCloud_cb2_logo'>
                  <img
                    src={value.icon}
                    alt={value.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      filter: 'grayscale(0.6)',
                    }}
                  />
                </div>
              ))}


            </div>

          </div>


        </div>

       
      </div>

    </div>
  );
};

export default LogoCloud;

